<template>
    <div class="modal is-active"  >
        <b-loading  :active.sync="isFullScreenSearching" ></b-loading>
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                 
                <p class="modal-card-title ">
                    <span v-if="type_AddEditColorTechniqueTransparent == 'cast' ">
                        Cast
                    </span>   
                    <span v-if="type_AddEditColorTechniqueTransparent == 'technique' ">
                        Technique 
                    </span>
                    <span v-if="type_AddEditColorTechniqueTransparent == 'transparent' ">
                        Transparent
                    </span>


                    <span class="has-text-grey is-size-5" v-if="mode==0">
                        Add New Mode
                    </span>
                    <span class="has-text-grey is-size-5" v-if="mode==1">
                        Edit Mode
                    </span>



                </p>
             



                 



                <!-- <p class="modal-card-title " v-if="mode =='U'" >Edit Mode</p>   -->
         
            </header>
            <section class="modal-card-body">
         
                <b-field label="Name "
                    :type="{ 'is-danger': hasEmptyName }"
                    :message="{ 'please some text': hasEmptyName }"
                              
                              >
                    <b-input v-model="dataAddEditColorTechniqueTransparentToEdit.name" >{{dataAddEditColorTechniqueTransparentToEdit.name}}</b-input>
                </b-field>
                <b-field label="Status">
                    <b-switch  type="is-success" v-model=" dataAddEditColorTechniqueTransparentToEdit.enabled "
                            ></b-switch>
                </b-field>

                <!-- {{dataAddEditColorTechniqueTransparentToEdit}}
                {{mode}}
                {{type_AddEditCastCysEpith}} -->
                
            </section>
            <footer class="modal-card-foot" style="justify-content: space-between;">
                <b-button type="is-danger"  @click="close">Cancel</b-button>
                <b-button type="is-success" :disabled="hasEmptyName" @click="save">Save</b-button>
            </footer>
        </div>
    </div>
</template>


<script>

import axios from "axios";
import { getBaseURLforBackEnd ,getConfigAxios  }  from '@/utils.js'
import { mapState } from "vuex";




export default {
    name : "AddEditColorTechniqueTransparent",
    computed:{
          ...mapState({
                access_token : state => state.master_data.access_token,
            }) 
    },
    props:{
        dataAddEditColorTechniqueTransparentToEdit : Object,
                                                //{   
                                                //      "id" : 5,
                                                //   	"name": "Hello I" ,
                                                //      "enabled" : false 
                                                // }



        mode : Number, //0 == add , 1 == edit
        type_AddEditColorTechniqueTransparent : String, // 'color','technique','transparent
    },
    methods:{
        close(){
          this.$emit('close')
        },
        save(){
              

              let endpoint = ''
              if(this.type_AddEditColorTechniqueTransparent=='color' &&  this.mode == 0){
                  endpoint ='addnew_ua_color_mst'
              }else if(this.type_AddEditColorTechniqueTransparent=='technique' &&  this.mode == 0){
                  endpoint ='addnew_ua_technique_mst'
              } else if(this.type_AddEditColorTechniqueTransparent=='transparent' &&  this.mode == 0){
                  endpoint ='addnew_ua_transparent_mst'
              } 

              if(this.type_AddEditColorTechniqueTransparent=='color' &&  this.mode == 1){
                  endpoint ='update_ua_color_mst'
              }else if(this.type_AddEditColorTechniqueTransparent=='technique' &&  this.mode == 1){
                  endpoint ='update_ua_technique_mst'
              } else if(this.type_AddEditColorTechniqueTransparent=='transparent' &&  this.mode == 1){
                  endpoint ='update_ua_transparent_mst'
              } 
              
              

              


              //  
              let  datTo = null
              if(this.mode==0){ // add new mode
                           datTo = {
                                 "name" :  this.dataAddEditColorTechniqueTransparentToEdit.name ,
                                 "enabled" :  this.dataAddEditColorTechniqueTransparentToEdit.enabled
                             }
              }  
              if(this.mode==1){ // edit mode
                           datTo = {
                                 "id" : this.dataAddEditColorTechniqueTransparentToEdit.id ,
                                 "name" :  this.dataAddEditColorTechniqueTransparentToEdit.name ,
                                 "enabled" :  this.dataAddEditColorTechniqueTransparentToEdit.enabled
                             }
              }      
              
              
                this.isFullScreenSearching = true
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/${endpoint}`,datTo,getConfigAxios())
                        .then(()=>{
                              this.isFullScreenSearching = false
                              this.$emit('closeWithDataChange',this.type_AddEditColorTechniqueTransparent)
                        })
               
              
                
        }
    },
    data(){
        return{
            isFullScreenSearching : false,
            hasEmptyName : false,
        }
    },
    watch:{
        'dataAddEditColorTechniqueTransparentToEdit.name' :{
            deep : true,
            handler: function(val){
                  this.hasEmptyName = !val
            }
        }
    }
}
</script>